export class FoodAdsGovernanceApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Open a sponsored-campaign charge ledger (budget + merchant cap). A second open of the same campaign is refused (409). */
    openCampaign(input) {
        return this.client.request({ method: 'POST', path: '/v1/food-ads-governance/campaigns', body: input, auth: true });
    }
    /** Charge one exposure — billed exactly once, never past budget/cap, refused while the kill switch is engaged. */
    chargeExposure(campaignId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-ads-governance/campaigns/${encodeURIComponent(campaignId)}/charge-exposure`, body: input, auth: true });
    }
    /** Read a campaign ledger + its current revision. */
    getCampaign(campaignId) {
        return this.client.request({ method: 'GET', path: `/v1/food-ads-governance/campaigns/${encodeURIComponent(campaignId)}`, auth: true });
    }
    /** List a merchant's campaign ledgers (newest first). */
    listByMerchant(merchantId) {
        return this.client.request({ method: 'GET', path: `/v1/food-ads-governance/merchants/${encodeURIComponent(merchantId)}/campaigns`, auth: true });
    }
    /** Engage the global sponsored kill switch for a scope — blocks every further charge instantly. */
    engageKillSwitch(scope, reason) {
        return this.client.request({ method: 'POST', path: `/v1/food-ads-governance/kill-switch/${encodeURIComponent(scope)}/engage`, body: reason !== undefined ? { reason } : {}, auth: true });
    }
    /** Release the global sponsored kill switch for a scope — charges resume. */
    disengageKillSwitch(scope) {
        return this.client.request({ method: 'POST', path: `/v1/food-ads-governance/kill-switch/${encodeURIComponent(scope)}/disengage`, body: {}, auth: true });
    }
    /** D854: the live kill-switch scopes - the one every charge answers to (`defaultScope`) with its posture. */
    listKillSwitchScopes() {
        return this.client.request({ method: 'GET', path: '/v1/food-ads-governance/kill-switch', auth: true });
    }
    /** Read the kill-switch posture for a scope (a scope never engaged answers the released default). */
    getKillSwitch(scope) {
        return this.client.request({ method: 'GET', path: `/v1/food-ads-governance/kill-switch/${encodeURIComponent(scope)}`, auth: true });
    }
}
//# sourceMappingURL=food-ads-governance.js.map